<template>
  <div />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { browser } from '@/user-context';

export default defineComponent({
  props: {
    url: {
      type: String,
    },
    // Force the hidden-iframe path even on browsers that normally open a new
    // tab. Needed when printing without a user gesture (e.g. auto-print after
    // checkout), where window.open would be popup-blocked.
    background: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  data() {
    return {
      iframeEl: null as HTMLIFrameElement | null,
    };
  },
  methods: {
    closePrint() {
      this.$emit('close');
      this.iframeEl?.remove();
      this.iframeEl = null;
    },
    // The printed page (register/documents/:id/print) triggers its own
    // window.print() inline once loaded, so this only wires up detection of
    // when that self-triggered print finishes or is cancelled.
    bindCloseHandlers() {
      const iframe = this.iframeEl?.contentWindow;
      if (!iframe) return;
      iframe.onbeforeunload = this.closePrint;
      iframe.onafterprint = this.closePrint;
    },
  },
  mounted() {
    const opensInTab =
      !this.background &&
      (browser.isSafari ||
        browser.isFirefox ||
        browser.isSamsungBrowser ||
        browser.isAndroid);

    if (opensInTab) {
      setTimeout(() => {
        window.open(this.url);
      }, 0);
    } else {
      const oHiddFrame = document.createElement('iframe');
      oHiddFrame.classList.add('js-print-iframe');
      oHiddFrame.style.position = 'fixed';
      oHiddFrame.style.right = '0';
      oHiddFrame.style.bottom = '0';
      oHiddFrame.style.width = '0';
      oHiddFrame.style.height = '0';
      oHiddFrame.style.border = '0';
      // Bind handlers after load so they attach to the loaded page's window,
      // not the transitional about:blank. Binding before load would set
      // onbeforeunload on blank — firing closePrint when the iframe navigates
      // to its src, not when the user closes the print dialog.
      oHiddFrame.onload = () => this.bindCloseHandlers();
      oHiddFrame.src = this.url as string;
      this.iframeEl = oHiddFrame;
      document.body.appendChild(oHiddFrame);
    }
  },
  unmounted() {
    // A remount (parent bumps :key for a new print) must not leave this
    // instance's iframe behind for a stale onload to act on, or for the next
    // instance's global-selector lookups to collide with.
    this.iframeEl?.remove();
    this.iframeEl = null;
  },
});
</script>
